export default "__VITE_ASSET__830c71fa__"